module.exports = __webpack_public_path__ + "img/symbol_0.96ca8f88.png";